export default __webpack_public_path__ + "static/media/logo.e709b779.jpg";